import Vue from 'vue'

const API_URL = '/api/add-on'

export default {
    namespaced: true,
    getters: {
        allAddOns: (state) => state.add_ons
    },
    state: {
        add_ons: []
    },
    mutations: {
        CREATE_ADD_ON(state, add_on) {
            state.add_ons.push(add_on)
        },
        ALL_ADD_ONS(state, add_ons) {
            state.add_ons = add_ons
        },
        UPDATE_ADD_ON(state, add_on) {
            var add_ons = [...state.add_ons]
            var index = add_ons.findIndex(x => x.id === add_on.id)
            if(index !== -1) {
                add_ons[index] = add_on
                state.add_ons = add_ons
            }
        },
        DELETE_ADD_ON(state, id) {
            state.add_ons = state.add_ons.filter((x) => x.id !== id)
        }
    },
    actions: {
        async create_add_on({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/create', form_data)
            commit('CREATE_ADD_ON', resp.data.add_on)
            return resp
        },

        async get_add_ons({commit}) {
            const resp = await Vue.prototype.$http.get(API_URL + '/list')
            commit('ALL_ADD_ONS', resp.data.data.add_ons)
            return resp
        },

        async update_add_on({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/update', form_data)
            commit('UPDATE_ADD_ON', resp.data.add_on)
            return resp
        },

        async delete_add_on({commit}, id) {
            const resp = await Vue.prototype.$http.delete(API_URL + '/delete/' + id)
            commit('DELETE_ADD_ON', id)
            return resp
        }

    }
}

